__turbopack_context__.v({
  "animatedText": "style-module-scss-module__7hpHsG__animatedText",
  "line": "style-module-scss-module__7hpHsG__line",
  "lineInner": "style-module-scss-module__7hpHsG__lineInner",
  "wrapper": "style-module-scss-module__7hpHsG__wrapper",
});
